import L from "leaflet";
import markerOrangeSVG from "../../../images/Icons/markerOrange.svg";
import markerRedSVG from "../../../images/Icons/markerRed.svg";
import markerYellowSVG from "../../../images/Icons/markerYellow.svg";
import markerHouseBlueSVG from "../../../images/Icons/markerHouseBlue.svg";

export const markerOrange = new L.Icon({
  iconUrl: markerOrangeSVG,
  iconRetinaUrl: markerOrangeSVG,
  iconAnchor: null,
  popupAnchor: [1, 1],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: new L.Point(40, 40),
  className: "leaflet-div-marker",
});

export const markerRed = new L.Icon({
    iconUrl: markerRedSVG,
    iconRetinaUrl: markerRedSVG,
    iconAnchor: null,
    popupAnchor: [1, 1],
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(40, 40),
    className: "leaflet-div-marker",
  });

  export const markerYellow = new L.Icon({
    iconUrl: markerYellowSVG,
    iconRetinaUrl: markerYellowSVG,
    iconAnchor: null,
    popupAnchor: [1, 1],
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(40, 40),
    className: "leaflet-div-marker",
  });

  export const markerHouseBlue = new L.Icon({
    iconUrl: markerHouseBlueSVG,
    iconRetinaUrl: markerHouseBlueSVG,
    iconAnchor: null,
    popupAnchor: [1, 1],
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(40, 40),
    className: "leaflet-div-marker",
  });
  
